import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Section } from "@sunwing/components";
import { RCLContext } from "../../components/RCL/RCLProvider";
import { RCL } from "../../components/RCL";
import { useRouting } from "../../hooks";
import { Loader } from "../../components/Loader";
import { Breadcrumb } from "../../components/Breadcrumb";
import { useOktaAuth } from "@okta/okta-react";
import config from "../../app/config";
import { VWQIcon } from "@sunwing/icons";
import ItemList from './ItemList';

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./GridPageVwq.module.scss");
  } else {
    styles = await import("./GridPage.module.scss");
  }
})();

const GridPage = () => {
  const { locale } = useContext(RCLContext);
  const { setCurrentRoute } = useRouting();
  const { oktaAuth } = useOktaAuth();
  const [gridPageItems, setGridPageItems] = useState(null);
  const [searchString, setSearchString] = useState('');
  const params = new URL(window.location.href).searchParams;
  const pageSlug = params.get('pageSlug');

  const getGridPageItems = async () => {

    const query = `
      query gridPageItemsData($locale: String, $skip:Int, $pageSlug:String!, $brandCode:String!) {
        gridPageItemCollection(locale: $locale, limit:100, skip:$skip, where: { pageSlug:$pageSlug, brand: {brandCode:$brandCode}}) {
          items {
            sys {
                id
                publishedAt
              }
           title
           description
           pageSlug
           fileCollection {
              items {
                url
                size
                description
              }
            }
            imageAsset
            landingPage {
              sys {
                id
              }
              slug
              landingPageLinkText
            }
            pageLink {
            ... on Link {
              sys {
                id
              }
              linkText
              url
              target
            }      
          }
            brand {
              brandCode
            }
          }
        }
      }`;

    await fetch(config.resourceServer.contentfulApimAgentGqlUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${oktaAuth.getAccessToken()}`,
      },
      body: JSON.stringify({
        query: query,
        variables: { 
          locale: locale === "fr" ? locale : "en-CA", 
          "skip":0,
          "pageSlug":pageSlug,
          brandCode:config.brand ? config.brand.toUpperCase() : 'SWG'
        },
      }),
    })
      .then((response) => response.json())
      .then(({ data, errors }) => {
        if (errors) {
          console.error(errors);
        }else{
          setGridPageItems(data?.gridPageItemCollection?.items);
        }
      });
  };

  const filteredItems = gridPageItems
      ?.slice()
      .filter(gridPageItem => gridPageItem.title == null || gridPageItem.title?.toLowerCase().includes(`${searchString}`))
      .sort((a, b)=> -a.sys.publishedAt.localeCompare(b.sys.publishedAt));

  useEffect(() => {
    if (setCurrentRoute) {
      setCurrentRoute({
        en: { path: "/en/gridPage" },
        fr: { path: "/fr/gridPage" },
      });
    };
    getGridPageItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.gridPage}>
      <Helmet>
        <title>
          {`Agent Portal - ${ RCL({ searchKey: `${config.brand}-${pageSlug}-title` }) }`}
        </title>
      </Helmet>
      {!config.isWestJetMode && gridPageItems && (
        <Breadcrumb pageSlug={"gridPage"} locale={locale} />
      )}
      {config.isWestJetMode && 
        (<>
          <div className={styles.gridPagePageHeaderRow}>
              <div className={styles.gridPagePageHeaderContainer}>
                <div className={styles.gridPageHeader}><RCL searchKey= {`${config.brand}-${pageSlug}-title`} /></div>
                  <div className={styles.gridPageSearchBar}>
                      <input placeholder={RCL({ searchKey: "search" }) } 
                          value={searchString} 
                          className={styles.gridPageSearchInput}
                          onChange={(e) => setSearchString(e.target.value.toLowerCase())}/>
                          <VWQIcon name="search" className={styles.gridPageSearchIcon}/>
                </div>
              </div>
          </div>
        </>)
      }
      
      <Section
        title={config.isWestJetMode ? "" : RCL({ searchKey: `${config.brand}-${pageSlug}-title` })}
        titleSize="h1"
        titleAlignment="left"        
      >
        <p className={  styles.gridPageDesc}>
        {<RCL searchKey={`${config.brand}-${pageSlug}-desc`} /> }
        </p>
        {!config.isWestJetMode && 
          (<>
            <div className={styles.gridPageSearchBar}>
              <input placeholder={ RCL({ searchKey: "search" }) } 
                    value={searchString} 
                    onChange={(e) => setSearchString(e.target.value.toLowerCase())}/>
            </div>
            <br></br>
            <br></br>
          </>)
        }
        {!gridPageItems && <Loader />}
        {filteredItems && filteredItems.length > 0 && (
          <ItemList key={filteredItems} items={filteredItems} />
        )}
      </Section>
    </div>
  );
};

export default GridPage;
